/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {useEffect, useState} from 'react';
import {
  Grid,
  useMediaQuery,
  styled,
  Box,
  Typography,
  Paper,
} from '@mui/material';
import {CSSTransition} from 'react-transition-group';
import qs from 'qs';
// @ts-ignore
import {getWindow} from 'ssr-window';

const window = getWindow();

// Import your icons (replace with actual imports)

import {
  handleTracking,
  parseShowcaseUrl,
  TrackEventUBA,
  openUrl,
} from '@jobseeker/common-core/utils';
import {SubCatPopUp} from './SubCAtPopUp';
import {categories, jobColors} from './constants';
import {getQueryParamsAndSeekerId} from './homePageJobs';
import {shallowEqual, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {useLoadAds} from '@jobseeker/common-core';
import {useRouter} from 'next/router';
import {Image} from '@jobseeker/lotus/components/Image';
// Mock data for categories

// Utility functions
const getQueryParams = () =>
  qs.parse(window.location.search, {ignoreQueryPrefix: true});
export const trimText = (name: string) =>
  name
    ? name
        .trim()
        .toLowerCase()
        .replace(/[`@!&|/\\#,+=()$~%.'"^:;*?<>{}]/g, '')
        .replace(/\s+/g, '-')
        .replace(/--+/g, '-')
    : '';

// Styled Components

const ScrollbarWrapper = styled(Box)(({theme}) => ({
  left: '0px',
  width: '60%',
  overflowY: 'auto',
  backgroundColor: 'white',
  borderBottomRightRadius: '81px',
  border: '1px solid #efefef',

  // Hide scrollbar for WebKit browsers
  '&::-webkit-scrollbar': {
    width: '0 !important',
  },

  [theme.breakpoints.down(1023)]: {
    display: 'none',
  },
  [theme.breakpoints.up(1024)]: {
    height: '200px',
  },
  [theme.breakpoints.between(1280, 1439)]: {
    height: '240px',
  },
  [theme.breakpoints.up(1440)]: {
    height: '260px',
  },
}));

const ScrollbarWrapper2 = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  left: '60%',
  width: '40%',
  overflowY: 'auto',
  backgroundColor: 'none',

  // Hide scrollbar for WebKit browsers
  '&::-webkit-scrollbar': {
    width: '0 !important',
  },

  [theme.breakpoints.down(1023)]: {
    display: 'none',
  },
  [theme.breakpoints.up(1024)]: {
    height: '203px',
  },
  [theme.breakpoints.between(1280, 1439)]: {
    height: '245px',
  },
  [theme.breakpoints.up(1440)]: {
    height: '272px',
  },
}));
const CategoryWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  minHeight: '600px',
  [theme.breakpoints.down('lg')]: {
    minHeight: '500px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '575px',
  },
}));

const CategoryItem = styled(Paper)(({theme}) => ({
  height: '157px',
  backgroundColor: 'theme.palette.background.paper',
  position: 'relative',
  boxShadow: 'none',
  overflow: 'visible',

  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
}));

const CategoryIcon = styled(Image)(() => ({
  width: '52px',
  height: '52px',
}));

// const HomeCatCompanies = styled(Box)(({theme}) => ({
//   width: '40%',
//   position: 'absolute',
//   top: '171px',
//   right: '0px',
//   paddingLeft: '20px',
//   paddingRight: '20px',
//   paddingTop: '35px',

//   a: {
//     display: 'inline-block',
//     marginTop: '20px',
//     marginBottom: '20px',
//     paddingLeft: '30px',
//     paddingRight: '30px',
//     cursor: 'pointer',

//     img: {
//       width: '100%',
//     },
//   },

//   [theme.breakpoints.down(1023)]: {
//     display: 'none',
//   },
// }));

export const ImgNextGen = ({
  srcWebp,

  alt,
  showBigImg = false,
  ...props
}: any) => {
  const [showFallbackImage, setShowFallbackImage] = useState(false);
  const colorIndex = Math.floor(Math.random() * 6);

  return (
    <picture>
      {/* <source srcset={srcWebp == 'https://staticlogo.hirist.com/webp/.png' ? '' : srcWebp} type="image/webp" />
        <Image src={fallback == 'https://staticlogo.hirist.com/.png' ? '' : fallback} alt={alt} {...props} /> */}
      {!showFallbackImage ? (
        <Image
          src={
            srcWebp == 'https://staticlogo.hirist.com/webp/.png' ? '' : srcWebp
          }
          onError={() => setShowFallbackImage(true)}
          alt={alt}
          {...props}
        />
      ) : showBigImg ? (
        <i className="icon-fallback-img" />
      ) : (
        <i
          className="icon-default-jobfeed logo-card default-job"
          style={{backgroundColor: jobColors[colorIndex]}}
        />
      )}
    </picture>
  );
};
export const getDevice = (userAgent: string): string => {
  const isMobile =
    /(iPad|iPhone|Android|webOS|iPod|BlackBerry|IEMobile|Opera Mini|Mobile)/i.test(
      userAgent
    ) || false;

  if (isMobile) {
    if (/android/i.test(userAgent)) {
      return 'android';
    }

    if (/iphone|ipad|ipod|iPhone|ios/.test(userAgent)) {
      return 'ios';
    }
  }

  return 'web';
};
export const getRefTagAndOrigin = () => {
  const url = window.location.href || '';
  const queryParams = getQueryParams();
  const refText = queryParams['ref'] || '';
  let origin = '';
  if (url.includes('/c/')) {
    origin = 'CategoryPage';
  } else if (url.includes('/k/')) {
    origin = 'KeywordPage';
  } else if (url.includes('/search/')) {
    origin = 'Search';
  } else if (url.includes('/similar_jobs.php')) {
    origin = 'SimilarJob';
  } else if (url.includes('/saved-jobs')) {
    origin = 'SavedJob';
  } else if (url.includes('/applied-jobs')) {
    origin = 'AppliedJob';
  } else if (url.includes('/allnotification')) {
    origin = 'NotificationPage';
  } else if (url.includes('/login')) {
    origin = 'home';
  } else {
    origin = 'Jobfeed';
  }
  return {origin, refText};
};

const useScreenSize = () => {
  const isMobile = useMediaQuery('(max-width: 550px)');
  const isSmall = useMediaQuery('(min-width: 551px) and (max-width: 1100px)');
  const isLarge = useMediaQuery('(min-width: 1101px) and (max-width: 1300px)');
  const isXL = useMediaQuery('(min-width: 1301px)');

  return {isMobile, isSmall, isLarge, isXL};
};
interface HomeCategoryProps {
  loginOpen: boolean;
}

export const HomeCategory = ({loginOpen}: HomeCategoryProps) => {
  const [id, setId] = useState<number | null>(1);
  const {device} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const [open, setOpen] = useState(false);
  const {isMobile} = useScreenSize();

  const router = useRouter();
  const [favCompanies, setFavCompanies] = useState<any[]>([]);
  const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string>('');

    useEffect(() => {
      if (typeof navigator !== 'undefined') {
        setUserAgent(navigator.userAgent || navigator.vendor || '');
      }
    }, []);

    return userAgent;
  };
  const userAgent = useUserAgent();
  useLoadAds(`5d64dc444fa6c747a100cfbe`, setFavCompanies);
  console.log({favCompanies});

  useEffect(() => {
    if (!loginOpen && favCompanies?.length > 0) {
      const fav = favCompanies
        ?.filter(c => c.categoryIds?.includes(id?.toString()))
        ?.slice(0, 8);

      const favTitle = fav?.map(comp => comp.title || '');
      const favIds = fav?.map(comp =>
        comp.companyId ? comp.companyId : parseShowcaseUrl(comp.link)
      );

      handleCompanyLogoView(id, favIds, favTitle);
    }
  }, [favCompanies]);

  const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
  const handleLogoHover = () => {
    const {origin, refText} = getRefTagAndOrigin();
    handleTracking('jsViewLogoPanel', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
    });

    handleUbaTracking('jsViewLogoPanel', 'view');
  };

  const CustomPrevArrow = (props: any) => {
    const {onClick, currentSlide} = props;
    const isDisabled = currentSlide === 0;
    return (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '-2%',

          transform: 'translateY(-50%)',
          zIndex: 1,
          cursor: 'pointer',
        }}
        onClick={isDisabled ? () => {} : onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="17"
          viewBox="0 0 22 17"
          fill="none"
        >
          <path
            d="M0.319616 7.40275L7.3029 0.419465C7.72897 -0.00660232 8.41996 -0.00660232 8.84603 0.419465C9.27218 0.84562 9.27218 1.53644 8.84603 1.9626L3.72545 7.08318H20.9089C21.5114 7.08318 22 7.57174 22 8.17431C22 8.7768 21.5114 9.26545 20.9089 9.26545H3.72545L8.84585 14.386C9.27201 14.8122 9.27201 15.503 8.84585 15.9292C8.63286 16.1421 8.35353 16.2487 8.07429 16.2487C7.79505 16.2487 7.5158 16.1421 7.30272 15.9292L0.319616 8.94588C-0.106539 8.51972 -0.106539 7.8289 0.319616 7.40275Z"
            fill={isDisabled ? 'rgba(0, 0, 0, 0.2)' : '#E9630C'}
          />
        </svg>{' '}
      </div>
    );
  };

  // Custom Next Arrow Component
  const CustomNextArrow = (props: any) => {
    const {onClick} = props;
    return (
      <div
        style={{
          position: 'absolute',
          left: '102%',
          top: '50%',

          transform: 'translateY(-50%)',
          zIndex: 1,
          cursor: 'pointer',
        }}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="17"
          viewBox="0 0 22 17"
          fill="none"
        >
          <path
            d="M21.6804 7.57098L14.6971 0.428986C14.271 -0.00676486 13.58 -0.00676486 13.154 0.428986C12.7278 0.864826 12.7278 1.57135 13.154 2.00719L18.2745 7.24414H1.09114C0.488568 7.24414 0 7.74382 0 8.36008C0 8.97626 0.488568 9.47602 1.09114 9.47602H18.2745L13.1541 14.713C12.728 15.1488 12.728 15.8553 13.1541 16.2912C13.3671 16.5089 13.6465 16.618 13.9257 16.618C14.205 16.618 14.4842 16.5089 14.6973 16.2912L21.6804 9.14918C22.1065 8.71334 22.1065 8.00682 21.6804 7.57098Z"
            fill={'#E9630C'}
          />
        </svg>{' '}
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    autoplay: false,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };

  const handleLogoClick = (url: any, title: any, companyId: any) => {
    setTimeout(() => {
      const {origin, refText} = getRefTagAndOrigin();
      handleTracking('jsClickLogo', {
        event_category: 'jsHomePage',
        Source: `${origin}`,
        CompanyId: `${companyId}`,
        CompanyName: `${title}`,
        Device: sessionStorage.getItem('device') || 'desktop',
        Ref: `${refText}`,
      });
      openUrl(url, '_blank');
    }, 0);
  };

  const {userId} = useSelector((state: AppState) => state.auth);

  const handleUbaTracking = (eventName: any, action: any) => {
    const {queryParams} = getQueryParamsAndSeekerId();

    TrackEventUBA(eventName, action, {
      ref: queryParams.ref || '',
      sessionUsername: userId ? userId.toString() : '',
    });
  };
  const handleCategoryHover = (
    catId: number,
    companyIds?: Array<string>,
    companyNames?: Array<string>
  ) => {
    setId(catId);
    if (isMobile) {
      setShowSubcategoryPopup(true);
    }
    TrackEventUBA('companyLogosView', 'view', {
      source: 'Companies Logo Homepage',
      page: 'Home Page',
      categoryID: catId || '',
      companyIDSArray: companyIds,
      companyNamesArray: companyNames,
    });
  };

  const handleCategoryClick = (url: string, catId: number) => {
    const {origin, refText} = getRefTagAndOrigin();

    handleTracking('jsClickCategory', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      CategoryId: `${catId}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
    });
    TrackEventUBA('jsCategoryClick', 'click', {
      ref: router?.query?.ref || '',
      sessionUsername: sessionStorage.getItem('userId') || '-1',
      page: 'jsHomePage',
      categoryID: catId || '',
      section: 'Category',
    });

    const fav = favCompanies
      ?.filter(c => c.categoryIds?.includes(catId.toString()))
      ?.slice(0, 8);

    const favTitle = fav?.map(comp => comp.title || '');
    const favIds = fav?.map(comp =>
      comp.companyId ? comp.companyId : parseShowcaseUrl(comp.link)
    );

    handleCompanyLogoView(catId, favIds, favTitle);

    if (isMobile) {
      setId(catId);

      setShowSubcategoryPopup(true);
      setOpen(true);
    } else if (url) {
      console.log({url});
      window.location.href = url;
    }
  };

  const onCloseSubcategoryPopup = () => {
    setTimeout(() => {
      setOpen(false);
    }, 0);
  };

  const createUrl = (name: string, id: number, type: string) => {
    const category = name
      .toLowerCase()
      .trim()
      .replace(/[*%$&']/g, '')
      .replace(/\s+/g, '-')
      .replace(/\//g, '-');
    return `/${type}/${category}-jobs${type === 'c' ? '' : ''}`;
  };

  const handleTagClick = (tagId: number) => {
    TrackEventUBA('jsCategoryClick', 'click', {
      page: 'jsHomePage',
      ref: router.query.ref || '',
      sessionUsername: sessionStorage.getItem('userId') || '-1',
      tagID: tagId || '',
      section: 'Tag',
    });
  };

  const handleCompanyLogoView = (
    catId: number | null,
    companyIds: Array<string>,
    companyNames: Array<string>
  ) => {
    TrackEventUBA('companyLogosView', 'view', {
      source: 'Companies Logo Homepage',
      page: 'Home Page',
      categoryID: catId || '',
      companyIDSArray: companyIds,
      companyNamesArray: companyNames,
    });
  };

  return (
    <CategoryWrapper>
      <Grid
        container
        spacing={2}
        sx={{
          cursor: 'pointer',
          backgroundColor: 'white',
          boxShadow: '0 6px 20px 0 rgba(0, 0, 0, .06)',
          border: '1px solid #efefef',
          pt: {xxs: 4, md: 0},
          pb: {xxs: 1, md: 0},
          mb: {xxs: 12, md: 0},
          ml: '0px',
          width: '100%',
        }}
      >
        {device == 'desktop' ? (
          <Box width="90%" ml={'4%'}>
            <Slider {...settings}>
              {categories
                ?.filter(e => e.icon)
                ?.map(category => (
                  <>
                    <CategoryItem
                      key={`category_panel_${category.id}`}
                      onMouseEnter={e => {
                        const companies =
                          favCompanies?.filter(
                            c => c.categoryIds?.includes(category.id.toString())
                          ) || [];

                        const companyIds =
                          companies.map(
                            c => c.companyId || parseShowcaseUrl(c.link)
                          ) || [];

                        const companyTitles = companies.map(c => c.title) || [];

                        handleCategoryHover(
                          category.id,
                          companyIds,
                          companyTitles
                        );
                      }}
                    >
                      <a
                        href={`${createUrl(
                          category.name,
                          category.id,
                          'c'
                        )}?ref=homepagecat`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => {
                          e.preventDefault();
                          const url = `${createUrl(
                            category.name,
                            category.id,
                            'c'
                          )}?ref=homepagecat`;
                          setTimeout(() => {
                            openUrl(url, '_blank');
                            handleCategoryClick('', category.id);
                          }, 0);
                        }}
                        style={{textDecoration: 'none', color: '#000'}}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          sx={{paddingTop: 3}}
                          overflow={'visible'}
                        >
                          <CategoryIcon
                            src={category.icon}
                            alt={category.name}
                          />
                          <Typography
                            variant="body1"
                            height="23px"
                            paddingTop="20px"
                            textAlign={'center'}
                            fontFamily={'Nunito Sans'}
                            fontWeight={700}
                            mb={{xxs: 4, md: 0}}
                            maxWidth={{md: 160, lg: 'auto'}}
                            overflow={'visible'}
                            color={
                              id === category.id
                                ? 'rgb(233, 99, 12)'
                                : 'textPrimary'
                            }
                          >
                            {category.name}
                          </Typography>
                          {id === category.id && !isMobile && (
                            <Box
                              width="52.91%"
                              height="4px"
                              bgcolor="rgb(233, 99, 12)"
                              borderRadius="4px"
                              mx="auto"
                              position="relative"
                              bottom={-55}
                            />
                          )}
                        </Box>
                      </a>
                    </CategoryItem>
                  </>
                ))}
            </Slider>
          </Box>
        ) : (
          <>
            {categories?.slice(0, 6)?.map(category => (
              <>
                <Grid
                  item
                  xxs={6}
                  sm={4}
                  md={2}
                  key={`category_panel_item_desktop_${category.id}`}
                  sx={{
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <CategoryItem
                    onMouseEnter={() => handleCategoryHover(category.id)}
                    onClick={() =>
                      setTimeout(() => {
                        handleCategoryClick(
                          `${createUrl(
                            category.name,
                            category.id,
                            'c'
                          )}?ref=homepagecat`,
                          category.id
                        );
                      }, 0)
                    }
                  >
                    <Box textAlign="center" py={2} mb={4} sx={{paddingTop: 0}}>
                      <CategoryIcon src={category.icon} alt={category.name} />
                      <Typography
                        variant="body1"
                        height="23px"
                        paddingTop="12px"
                        fontFamily={'Nunito Sans'}
                        fontWeight={700}
                        paddingLeft={4}
                        paddingRight={4}
                        mb={{xxs: 4, md: 0}}
                        color={
                          id === category.id
                            ? 'rgb(233, 99, 12)'
                            : 'textPrimary'
                        }
                      >
                        {category.name}
                      </Typography>
                      {id === category.id && !isMobile && (
                        <Box
                          width="52.91%"
                          height="4px"
                          bgcolor="rgb(233, 99, 12)"
                          borderRadius="4px"
                          mx="auto"
                          position="relative"
                          bottom={-62}
                        />
                      )}
                    </Box>
                  </CategoryItem>
                </Grid>
              </>
            ))}
          </>
        )}
      </Grid>
      <Box display="flex" key={id}>
        <ScrollbarWrapper>
          {categories?.map(category => (
            <CSSTransition
              in={id === category.id}
              timeout={1000}
              key={`category_panel_item_mobile_${category.id}`}
              classNames="subcategory"
              unmountOnExit
              sx={{
                transition:
                  'opacity 300ms ease-in-out, transform 300ms ease-in-out',
              }}
            >
              {state => (
                <Grid
                  container
                  spacing={2}
                  className="hirist-sub-categories-wrapper"
                  sx={{
                    left: '0px',
                    backgroundColor: '#ffffff',
                    paddingBottom: '16px',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    marginTop: 1,
                    height: '95%',
                    opacity: state === 'entered' ? 1 : 0,
                    transform:
                      state === 'entered'
                        ? 'translateY(0)'
                        : 'translateY(-10px)',
                  }}
                >
                  {category?.tags?.slice(0, 8)?.map(tag => (
                    <>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={`category_panel_item_mobile_view_${tag.id}`}
                      >
                        <a
                          href={`${createUrl(
                            tag.name,
                            tag.id,
                            'k'
                          )}?ref=homepagetag`}
                          style={{position: 'relative', width: '100%'}}
                          onClick={e => {
                            e.preventDefault();
                            const url = `${createUrl(
                              tag.name,
                              tag.id,
                              'k'
                            )}?ref=homepagetag`;
                            setTimeout(() => {
                              openUrl(url, '_blank');
                              handleTagClick(tag?.id);
                            }, 0);
                          }}
                        >
                          <span />
                          <div
                            style={{
                              position: 'relative',
                              width: '90%',
                              height: '90%',
                              // width: "auto"
                              // height: isSmall ? '70px' : '91px', // Ensure it's the same as the image height
                            }}
                          >
                            <ImgNextGen
                              srcWebp={`https://staticlogo.hirist.com/webp/V2${trimText(
                                tag.name
                              )}.webp`}
                              fallback={`https://staticlogo.hirist.com/V2${trimText(
                                tag.name
                              )}.png`}
                              alt={tag.name}
                              style={{
                                display: 'block',
                                height: '100%',
                                width: '100%',
                                maxHeight: '100px',
                              }}
                            />
                          </div>
                        </a>
                      </Grid>
                    </>
                  ))}
                </Grid>
              )}
            </CSSTransition>
          ))}
        </ScrollbarWrapper>
        <ScrollbarWrapper2>
          {categories?.map(category => (
            <CSSTransition
              key={`category_panel_item_desktop_view_${category.id}`}
              in={id === category.id}
              timeout={0}
              unmountOnExit
            >
              <Box onMouseEnter={handleLogoHover}>
                <Grid
                  container
                  spacing={2}
                  className="hirist-sub-categories-wrapper"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  {favCompanies.length > 0 &&
                    favCompanies
                      ?.filter(
                        c => c.categoryIds?.includes(category.id.toString())
                      )
                      ?.slice(0, 8)
                      ?.map(company => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          display="flex"
                          key={company.jobId}
                          justifyContent="center"
                        >
                          <a
                            key={company.companyId}
                            className="col-4"
                            href={company.link}
                            rel="nofollow"
                            onClick={e => {
                              e.preventDefault();
                              const url = company.link;
                              setTimeout(() => {
                                handleLogoClick(
                                  company.link,
                                  company.title,
                                  company.companyId
                                );
                                TrackEventUBA('companyLogosClick', 'click', {
                                  page: 'Homepage',
                                  sessionUsername:
                                    sessionStorage.getItem('userId') || '',
                                  companyID:
                                    company?.companyId ||
                                    parseShowcaseUrl(company?.link) ||
                                    '',
                                  categoryID: category.id || '',
                                  source: 'Companies Logo Homepage',
                                  companyName: company?.title || '',
                                });
                                openUrl(url, '_blank');
                              }, 0);
                            }}
                          >
                            <Image
                              src={company.companyLogo}
                              alt={company.title}
                              style={{
                                cursor: 'pointer',
                                width: '178px',
                                height: '43px',
                                paddingLeft: 30,
                                paddingRight: 30,
                              }}
                            />
                          </a>
                        </Grid>
                      ))}
                </Grid>
              </Box>
            </CSSTransition>
          ))}
        </ScrollbarWrapper2>

        <CSSTransition
          in={showSubcategoryPopup}
          timeout={0}
          classNames="animate"
          unmountOnExit
        >
          <>
            <SubCatPopUp
              onCloseSubcategoryPopup={onCloseSubcategoryPopup}
              subcategories={categories?.find(c => c.id === id)?.tags}
              category={categories?.find(c => c.id === id)}
              modalState={showSubcategoryPopup}
              companies={favCompanies.filter(
                co => co.categoryIds?.includes(id?.toString())
              )}
              prefText={''}
              handleLogoClick={handleLogoClick}
              open={open}
            />
          </>
        </CSSTransition>
      </Box>
    </CategoryWrapper>
  );
};
